export enum AffectSubscriptionEnum {
    PAUSE_EXTENDS_DURATION = 'pause_extends_duration',
    PAUSE_WITHIN_DURATION = 'pause_within_duration'
}
